import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=51bb8714&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb8714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51bb8714')) {
      api.createRecord('51bb8714', component.options)
    } else {
      api.reload('51bb8714', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=51bb8714&scoped=true&", function () {
      api.rerender('51bb8714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/account/components/MainTable.vue"
export default component.exports